import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, defs, linearGradient, stop } from 'recharts';
import './Revenuechart.css';

const data = [
  { name: 'Jan', previous: 0, recent: 50 },
  { name: 'Feb', previous: 100, recent: 250 },
  { name: 'Mar', previous: 150, recent: 100 },
  { name: 'Apr', previous: 100, recent: 50 },
  { name: 'May', previous: 50, recent: 100 },
  { name: 'Jun', previous: 100, recent: 150 },
];

const Revenuechart = () => {
  return (
    <div className="chart-container1">
      <div className="chart-header1">
        <h2>Revenue</h2>
        <div className="chart-legend1">
          <span className="legend-item previous1">Previous 6 month</span>
          <span className="legend-item recent1">Recent 6 month</span>
        </div>
        <select className="chart-dropdown1">
          <option>Last 6 Months</option>
          {/* More options can be added here */}
        </select>
      </div>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{
            top: 10, right: 0, left: 0, bottom: 150,
          }}
        >
          <defs>
            <linearGradient id="colorRecent" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#14c8ff" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#14c8ff" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Area type="monotone" dataKey="recent" stroke="#14c8ff" fillOpacity={1} fill="url(#colorRecent)" />
          <Line type="monotone" dataKey="previous" stroke="#8a4af3" strokeWidth={2} dot={{ stroke: '#8a4af3', strokeWidth: 2 }} strokeDasharray="5 5" />
          <Line type="monotone" dataKey="recent" stroke="#14c8ff" strokeWidth={2} dot={{ stroke: '#14c8ff', strokeWidth: 2 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Revenuechart;
